import { FormId, getFormAssets } from '../utils/formAssets';
import { useIsMobile } from './useIsMobile';

export function useHeaderImage(formId: FormId): string {
  const isMobile = useIsMobile();
  const assets = getFormAssets(formId);
  return isMobile ? assets.headerMobile : assets.headerDesktop;
}
